import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { MaterialModule } from 'src/app/material.module';
import { LookupService } from 'src/app/services/lookup.service';

@Component({
  selector: 'app-doctor-dropdown',
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './doctor-dropdown.component.html',
  styleUrl: './doctor-dropdown.component.scss'
})
export class DoctorDropdownComponent implements OnInit, OnDestroy {
  doctorControl = new FormControl();
  doctorslist: CommonDropDown[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<DoctorDropdownComponent>,
    private _lookupService: LookupService,
    @Inject(MAT_DIALOG_DATA) private _data: { Date?: Date }
  ) { }

  ngOnInit(): void {
    const date = this._data?.Date;

    const doctors$ = date
      ? this._lookupService.getDoctors(date)
      : this._lookupService.doctors$;

    doctors$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.doctorslist = data || [];
      });

    this.doctorControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((doctorId) => {
      if (doctorId) {
        this.dialogRef.close(doctorId);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}